import BaseCommand from "@/models/api/commands/BaseCommand";

export class RecalculateAllOrderItemsCommand extends BaseCommand {
  CommandName = "RecalculateAllOrderItems";
  Command: number;
  constructor(sessionId: string, operationId: string, dateType: number) {
    super(sessionId, operationId);
    this.Command = dateType;
  }
}
